import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ErrorResponse } from './../../models/error-response';

@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  private errors = new Subject<ErrorResponse>();

  constructor() {}

  public addErrors = (errors: ErrorResponse): void => this.errors.next(errors);

  public getErrors = () => this.errors.asObservable();
}
